class JerseySelector {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-jersey-track]');
    this.tabs = Array.from(root.querySelectorAll('[data-jersey-tab]'));
    this.cards = Array.from(root.querySelectorAll('[data-jersey-card]'));
    this.dots = Array.from(root.querySelectorAll('[data-jersey-dot]'));
    this.track.style.setProperty('--jersey-count', this.cards.length);

    this.tabs.forEach((tab) => tab.addEventListener('click', () => this.goTo(Number(tab.dataset.index))));
    this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index))));

    this.scrollTicking = false;
    this.track.addEventListener('scroll', () => {
      if (this.scrollTicking) return;
      this.scrollTicking = true;
      requestAnimationFrame(() => {
        this.scrollTicking = false;
        this.syncFromScroll();
      });
    });
  }

  isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  goTo(index) {
    if (this.isDesktop()) return;
    const card = this.cards[index];
    if (card) this.track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
    this.setActive(index);
  }

  syncFromScroll() {
    if (this.isDesktop() || !this.track.clientWidth) return;
    const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
    this.setActive(index);
  }

  setActive(index) {
    this.tabs.forEach((tab, i) => tab.classList.toggle('is-active', i === index));
    this.cards.forEach((card, i) => card.classList.toggle('is-active', i === index));
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }
}

document.querySelectorAll('.custom-comparison-grid').forEach((el) => new JerseySelector(el));
